module.exports = __webpack_public_path__ + "img/insular-header-pt.c10c87e0.png";